import { workspaceApiFetch } from '@affine/core/modules/cloud';
import { useEffect, useState } from 'react';

export interface InboundWebhook {
  credentialId: string;
  name: string;
  webhookUrl: string;
}

/**
 * The workspace's inbound webhooks the current user may bind (RBAC-filtered
 * by the backend). Loaded only while `enabled`, i.e. while an automation uses
 * or is about to use the webhook trigger.
 */
export function useInboundWebhooks(
  workspaceId: string | undefined,
  enabled: boolean
): InboundWebhook[] {
  const [webhooks, setWebhooks] = useState<InboundWebhook[]>([]);
  useEffect(() => {
    if (!enabled || !workspaceId) return;
    let current = true;
    workspaceApiFetch(
      `/api/workspace/${workspaceId}/inbound-webhooks`,
      { credentials: 'include' },
      {
        workspaceId,
        category: 'workspace-api',
        key: 'inbound-webhooks',
        mode: 'background',
        priority: 'background',
      }
    )
      .then(res => (res.ok ? res.json() : []))
      .then((data: InboundWebhook[] | null) => {
        if (!current) return;
        setWebhooks(
          (data ?? []).map(webhook => ({
            credentialId: webhook.credentialId,
            name: webhook.name,
            webhookUrl: webhook.webhookUrl,
          }))
        );
      })
      .catch(() => {
        if (current) setWebhooks([]);
      });
    return () => {
      current = false;
    };
  }, [enabled, workspaceId]);
  return webhooks;
}
